import { render, staticRenderFns } from "./CompareColumnMain.vue?vue&type=template&id=0010fc94&scoped=true&"
import script from "./CompareColumnMain.vue?vue&type=script&lang=ts&"
export * from "./CompareColumnMain.vue?vue&type=script&lang=ts&"
import style0 from "./CompareColumnMain.vue?vue&type=style&index=0&id=0010fc94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0010fc94",
  null
  
)

export default component.exports